import React, { useState, useEffect } from 'react'
import Header from '../BaseComponents/Header'
import FotterMain from '../BaseComponents/FotterMain'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL, becomeDealer, becomeHIAuthorizedDealer, GetDealerLocation } from '../../networkCalls';
import SEO from '../BaseComponents/SEO';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Link } from "react-router-dom";
import { Autocomplete } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { actionTypes, useStateValue } from '../../store';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
const validationSchema = yup.object({
    name: yup
        .string('Enter your Name')
        .required('Full Name is a required field'),
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email ID is a required field'),
    mobile: yup
        .string('')
        .required('Mobile Number a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(10, 'Enter 10 digit mobile number')
        .max(10, 'Enter 10 digit mobile number'),
    address: yup
        .string('Enter your address')
        .required('Address is a required field'),
    city: yup
        .string('Enter your city')
        .required('City is a required field'),
    state: yup
        .string('Enter your state')
        .required('State is a required field'),
    pincode: yup
        .string('')
        .required('Postal Code is a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(6, 'Enter 6 digit Postal Code')
        .max(6, 'Enter 6 digit Postal Code'),
    country: yup
        .string('Enter your state')
        .required('Country is a required field'),
    geographical: yup
        .string('Enter your state')
        .required('Geographical Coverage is a required field'),
    aboutbusiness: yup
        .string('Enter your state')
        .required('About your Business is a required field'),
    firmName: yup
        .string('Enter your firm name')
        .required('Firm Name is a required field'),


});
const validationSchema1 = yup.object({
    dealerCode: yup
        .string('Enter Dealer Code')
        .required('Dealer Code is a required field'),
    name: yup
        .string('Enter your Name')
        .required('Full Name is a required field'),

    mobile: yup
        .string('')
        .required('Mobile Number a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(10, 'Enter 10 digit mobile number')
        .max(10, 'Enter 10 digit mobile number'),

    city: yup
        .string('Enter your city')
        .required('City is a required field'),
    state: yup
        .string('Enter your state')
        .required('State is a required field'),
    pincode: yup
        .string('')
        .required('Postal Code is a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(6, 'Enter 6 digit Postal Code')
        .max(6, 'Enter 6 digit Postal Code'),


    aboutbusiness: yup
        .string('Enter your state')
        .required('About your Business is a required field'),
    firmName: yup
        .string('Enter your firm name')
        .required('Firm Name is a required field'),


});
const BecomeAHiValuePlusDealer = () => {
    //  const [loading, setLoading] = useState(true);
    const [locationDdl, setLocationDdl] = useState([])
    const [DealerDataList, setDealerDataList] = useState([]);
    const [formsuccessloading, setFormSuccessloading] = useState(false);
    const [successmessage, setSuccessmessage] = useState('');

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [{ token, huid }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const toTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        // toTop();
    }, []);

    const formik = useFormik({
        initialValues: {
            name: '',
            mobile: '',
            email: '',
            address: '',
            city: '',
            state: '',
            pincode: '',
            country: '',
            geographical: '',
            aboutbusiness: '',
            firmName: ''
        },

        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log('data to push', values)
            setLoading(true);
            becomeDealer(values).then((res) => {
                setLoading(false);
                switch (res.data.status) {
                    case 1:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        setSuccessmessage(res.data.msz);
                        setFormSuccessloading(true);
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            });

        },
    });
    const formikdealer = useFormik({
        initialValues: {
            dealerCode: "",
            name: '',
            mobile: '',

            city: '',
            state: '',
            pincode: '',

            aboutbusiness: '',
            firmName: ''
        },

        validationSchema: validationSchema1,
        onSubmit: (values, formikHelpers) => {
            const { resetForm } = formikHelpers; // ✅ IMPORTANT
            console.log('data to push', values)
            var data = new FormData();
            // data.append("customerId", huid);
            // data.append("XAuth", token);
            data.append("dealerCode", values.dealerCode);
            data.append("name", values.name);
            data.append("mobile", values.mobile);
            data.append("state", values.state);
            data.append("city", values.city);
            data.append("pincode", values.pincode);
            data.append("aboutbusiness", values.aboutbusiness);
            data.append("firmName", values.firmName);
            setLoading(true);
            becomeHIAuthorizedDealer(data).then((res) => {
                setLoading(false);
                switch (res.data.status) {
                    case 1:
                        console.log('res data', res.data)
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        resetForm();
                        setSuccessmessage(res.data.msz);
                        setFormSuccessloading(true);
                        setIsADealer(false);
                        setShow(false);
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            });

        },
    });

    const cddl = [
        {
            value: 'india',
            label: 'India',
        },
    ];
    const [agree, setAgree] = useState(false);
    const haveAgree = (event) => {
        setAgree(event.target.checked);
    };
    const [isADealer, setIsADealer] = useState(false);
    const [show, setShow] = useState(false);


    const pullGetDealerLocation = () => {
        setLoading(true)
        GetDealerLocation().then((res) => {
            console.log('GetDealerLocation---0-', res?.data?.location)
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    const transformedLocations = Object.entries(res.data.location);
                    setStates(transformedLocations?.map(([state]) => state)); // Array of state
                    setLocationDdl(transformedLocations);
                    return true;
                case 0:
                    setStates([]);
                    setLocationDdl([]);
                    break;
                default:
                    return;
            }
        })
    }
    const handleStateChange = (event, value) => {
        setSelectedState(value);
        const selectedLocation = locationDdl.find(([state]) => state == value);
        setCities(selectedLocation ? Object.keys(selectedLocation[1]) : []); // Get cities based on selected state
        formikdealer.setFieldValue('state', value);
        formikdealer.setFieldValue('city', '');
    };

    const handleCityChange = (event, value) => {
        if (value) {
            formikdealer.setFieldValue('city', value.label);
            const selectedState = formikdealer.values.state;
            const citiesForState = locationDdl.find(([state]) => state == selectedState);
            if (citiesForState) {
                const [, cities] = citiesForState; // Get the cities object
                const selectedCityData = cities[value.label];
                if (selectedCityData) {
                    const selectedPincodes = selectedCityData.pincode;
                    setPincodeOptions(selectedPincodes);
                    // formikdealer.setFieldValue('pincode', selectedPincodes[0] || '');
                    formikdealer.setFieldValue('pincode', '');
                } else {
                    setPincodeOptions([]);
                    formikdealer.setFieldValue('pincode', '');
                }
            } else {
                setPincodeOptions([]);
                formikdealer.setFieldValue('pincode', '');
            }

        } else {
            formikdealer.setFieldValue('city', '');
            setPincodeOptions([]);
            formikdealer.setFieldValue('pincode', '');
        }
    };


    useEffect(() => {
        pullGetDealerLocation()
    }, []);
    return (
        <>
            <SEO
                title="Become a Dealer"
                description=""
                name="HIPP - Honda India Power"
                url="https://www.hondaindiapower.com/become-a-dealer"
                type='Website' />
            <Header />
            <div className="post-view__header post-header post-header--has-image" style={{ display: 'block' }}>
                <div className="post-header__image post-header__image-car " style={{ textAlign: 'center' }}>
                    <LazyLoadImage
                        alt=""
                        effect="blur"
                        className='img-fluid'
                        src={`https://hondaold.wipl.co.in/front/media/home-why-honda-parallax.jpg`}
                    />
                </div>
            </div>
            <div className='innerpagebg pt-5 pb-5' style={{ zIndex: '1', position: 'relative' }}>
                {
                    formsuccessloading && <div className='col-lg-8 col-mg-12 col-sm-12 col-12 text-start m-auto'>

                        <div className='card p-4 rounded-0 shadow-sm text-start'>
                            <div> <KeyboardBackspaceIcon className='txtred cursor-pointer' onClick={() => setFormSuccessloading(false)} /></div>
                            <h3 className=' m-0 fw-bold text-success text-center'>{successmessage}</h3>
                            {/* <p className='mt-2 text-success f16'>{successmessage}</p> */}
                        </div>
                    </div>
                }

                {
                    !formsuccessloading && <>


                        {isADealer ? <div className='container pt-1 pb-5' style={{ textAlign: 'justify' }}>
                            <div className='col-lg-8 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                                <div className='card p-4 rounded-0 shadow-sm'>
                                    <div className="d-flex gap-2 align-items-center text-left mb-4">
                                        <KeyboardBackspaceIcon className='txtred cursor-pointer' onClick={() => setIsADealer(false)} />
                                        <h3 className=' m-0 fw-bold txtdgray'>
                                            Become An <span className='txtred'>Authorised Dealer</span> for Hi Value<sup>+</sup>.</h3>
                                    </div>
                                    <p className='mt-2 f16'>Kindly enter the required information if you wish to obtain<br />authorisation as a Honda Dealer.</p>
                                    <hr className='mt-0' />
                                    <form onSubmit={formikdealer.handleSubmit} autoComplete="off">
                                        <div className='row'>
                                            <div className='col-12'>
                                                <TextField
                                                    className='mb-3 w-100'
                                                    variant="standard"
                                                    id="dealerCode"
                                                    name="dealerCode"
                                                    label="Dealer Code *"
                                                    type="text"
                                                    value={formikdealer.values.dealerCode}
                                                    onChange={(e) => {
                                                        formikdealer.setFieldValue("dealerCode", e.target.value.replace(/[^a-z0-9\s]/gi, ''));
                                                    }}
                                                    error={formikdealer.touched.dealerCode && Boolean(formikdealer.errors.dealerCode)}
                                                    helperText={formikdealer.touched.dealerCode && formikdealer.errors.dealerCode}
                                                />
                                            </div>
                                            <div className='col-12'>
                                                <TextField
                                                    className='mb-3 w-100'
                                                    variant="standard"
                                                    id="firmName"
                                                    name="firmName"
                                                    label="Firm Name *"
                                                    type="text"
                                                    value={formikdealer.values.firmName}
                                                    // onChange={formikdealer.handleChange}
                                                    onChange={(e) => {
                                                        formikdealer.setFieldValue("firmName", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                    }}
                                                    error={formikdealer.touched.firmName && Boolean(formikdealer.errors.firmName)}
                                                    helperText={formikdealer.touched.firmName && formikdealer.errors.firmName}
                                                />
                                            </div>
                                            <div className='col-12'>
                                                <TextField
                                                    className='mb-3 w-100'
                                                    variant="standard"
                                                    id="name"
                                                    name="name"
                                                    label="Contact Person Name *"
                                                    type="text"
                                                    value={formikdealer.values.name}
                                                    onChange={(e) => {
                                                        formikdealer.setFieldValue("name", e.target.value.replace(/[^a-z0-9\s]/gi, ''));
                                                    }}
                                                    error={formikdealer.touched.name && Boolean(formikdealer.errors.name)}
                                                    helperText={formikdealer.touched.name && formikdealer.errors.name}
                                                />
                                            </div>
                                            <div className='col-12'>
                                                <TextField
                                                    variant="standard"
                                                    className='mb-3 w-100'
                                                    label="Mobile Number *"
                                                    inputProps={{
                                                        maxLength: 10
                                                    }}
                                                    id="mobile"
                                                    name="mobile"
                                                    value={formikdealer.values.mobile}
                                                    // onChange={formikdealer.handleChange}
                                                    onChange={(e) => {
                                                        formikdealer.setFieldValue("mobile", e.target.value.replace(/[^0-9]/g, ''));
                                                    }}
                                                    error={formikdealer.touched.mobile && Boolean(formikdealer.errors.mobile)}
                                                    helperText={formikdealer.touched.mobile && formikdealer.errors.mobile}
                                                />
                                            </div>



                                            <div className='col-12'>
                                                <Autocomplete
                                                    disablePortal
                                                    className='mb-3'
                                                    options={loading ? [{ label: "Loading...", id: 0 }] : states}
                                                    id="state"
                                                    name="state"
                                                    getOptionLabel={option => option.label || option} // Return label if it exists; otherwise, return the state name
                                                    // defaultValue={}
                                                    onChange={handleStateChange}
                                                    value={formikdealer.values?.state}
                                                    sx={{ width: '100%' }}
                                                    renderInput={(params) => <TextField
                                                        variant="standard" {...params}
                                                        required
                                                        error={formikdealer.touched.state && Boolean(formikdealer.errors.state)}
                                                        helperText={formikdealer.touched.state && formikdealer.errors.state}
                                                        label="Select State" />}
                                                />
                                                {/* <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="state"
                                            name="state"
                                            label="State *"
                                            type="text"
                                            value={formikdealer.values.state}
                                            // onChange={formikdealer.handleChange}
                                            onChange={(e) => {
                                                formikdealer.setFieldValue("state", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formikdealer.touched.state && Boolean(formikdealer.errors.state)}
                                            helperText={formikdealer.touched.state && formikdealer.errors.state}
                                        /> */}
                                            </div>
                                            <div className='col-12'>

                                                <Autocomplete
                                                    disablePortal
                                                    className='mb-3'
                                                    options={cities.map(city => ({ label: city }))}
                                                    id="city"
                                                    name="city"
                                                    getOptionLabel={option => option.label}
                                                    onChange={handleCityChange}
                                                    value={formikdealer.values.city ? { label: formikdealer.values.city } : null}
                                                    sx={{ width: '100%' }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            variant="standard"
                                                            required
                                                            error={formikdealer.touched.city && Boolean(formikdealer.errors.city)}
                                                            helperText={formikdealer.touched.city && formikdealer.errors.city}
                                                            {...params}
                                                            label="Select City"
                                                        />
                                                    )}
                                                />
                                                {/* <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="city"
                                            name="city"
                                            label="City *"
                                            type="text"
                                            value={formikdealer.values.city}
                                            // onChange={formikdealer.handleChange}
                                            onChange={(e) => {
                                                formikdealer.setFieldValue("city", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formikdealer.touched.city && Boolean(formikdealer.errors.city)}
                                            helperText={formikdealer.touched.city && formikdealer.errors.city}
                                        /> */}
                                            </div>
                                            <div className='col-12'>
                                                <Autocomplete

                                                    className='mb-3'
                                                    options={pincodeOptions.map(pincode => ({ label: pincode }))}
                                                    id="pincode"
                                                    name="pincode"
                                                    getOptionLabel={option => option.label}
                                                    onChange={(event, value) =>
                                                        formikdealer.setFieldValue('pincode', value ? value.label : '')
                                                    }
                                                    value={formikdealer.values.pincode ? { label: formikdealer.values.pincode } : null}
                                                    sx={{ width: '100%' }}
                                                    renderInput={(params) => (
                                                        <TextField

                                                            variant="standard"
                                                            {...params}
                                                            label="Select Pincode"
                                                        />
                                                    )}
                                                />
                                                {/* <TextField
                                            variant="standard"
                                            className='mb-3 w-100'
                                            label="Postal Code *"
                                            inputProps={{
                                                maxLength: 6
                                            }}
                                            id="pincode"
                                            name="pincode"
                                            value={formikdealer.values.pincode}
                                            // onChange={formikdealer.handleChange}
                                            onChange={(e) => {
                                                formikdealer.setFieldValue("pincode", e.target.value.replace(/[^0-9]/g, ''));
                                            }}
                                            error={formikdealer.touched.pincode && Boolean(formikdealer.errors.pincode)}
                                            helperText={formikdealer.touched.pincode && formikdealer.errors.pincode}
                                        /> */}
                                            </div>
                                            {/* <div className='col-12'>
                                        <Autocomplete
                                            disablePortal
                                            id="country"
                                            className='mb-3'
                                            name="country"
                                            getOptionLabel={option => option.label}
                                            options={cddl}
                                            onChange={(e, value) => {
                                                //console.log('pas', value.value)
                                                formik.setFieldValue('country', value.value);
                                            }}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField
                                                variant="standard" {...params}
                                                error={formik.touched.country && Boolean(formik.errors.country)}
                                                helperText={formik.touched.country && formik.errors.country}
                                                label="Select Country *" />}
                                        />
                                    </div> */}


                                            <div className='col-12'>
                                                <TextField
                                                    className='mb-3 w-100'
                                                    variant="standard"
                                                    id="aboutbusiness"
                                                    multiline
                                                    rows={2}
                                                    name="aboutbusiness"
                                                    label="Tell us about your Business *"
                                                    type="text"
                                                    value={formikdealer.values.aboutbusiness}
                                                    // onChange={formikdealer.handleChange}
                                                    onChange={(e) => {
                                                        formikdealer.setFieldValue("aboutbusiness", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                    }}
                                                    error={formikdealer.touched.aboutbusiness && Boolean(formikdealer.errors.aboutbusiness)}
                                                    helperText={formikdealer.touched.aboutbusiness && formikdealer.errors.aboutbusiness}
                                                />
                                            </div>
                                            <div className='col-12'>
                                                <div className='f12 mb-3'>
                                                    <div className='d-flex align-items-center'>
                                                        <div><FormGroup>
                                                            <FormControlLabel className='f14' control={<Checkbox className='f14' checked={agree} onChange={haveAgree} />} label="" />
                                                        </FormGroup></div>
                                                        <div className='fw-bold'>I accept the <Link to="/terms-of-use" target='_blank'>Terms & Privacy Policy</Link></div>
                                                    </div>
                                                </div>
                                                {!loading ? <Button color="error"
                                                    disabled={!agree}
                                                    variant="contained" className='w-100' type="submit">
                                                    Submit
                                                </Button> : <LoadingButton className="w-100"
                                                    loading
                                                    //loadingPosition="end"
                                                    variant="contained"
                                                >
                                                    Submit...
                                                </LoadingButton>}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> : show ? <div className='col-lg-8 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                            <div className='card p-4 rounded-0 shadow-sm'>
                                <div className="d-flex gap-2 align-items-center  text-left mb-4">
                                    <KeyboardBackspaceIcon className='txtred cursor-pointer' onClick={() => setShow(false)} />
                                    <h3 className=' m-0 fw-bold txtdgray'>
                                        Become An <span className='txtred'>Authorised Dealer</span> for Hi Value<sup>+</sup>.</h3>
                                </div>
                                <p className='mt-2 f16'>Kindly enter the required information if you wish to obtain<br />authorisation as a Honda Dealer.</p>
                                <hr className='mt-0' />
                                <form onSubmit={formik.handleSubmit} autoComplete="off">
                                    <div className='row'>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="name"
                                                name="name"
                                                label="Contact Person Name *"
                                                type="text"
                                                value={formik.values.name}
                                                onChange={(e) => {
                                                    formik.setFieldValue("name", e.target.value.replace(/[^a-z0-9\s]/gi, ''));
                                                }}
                                                error={formik.touched.name && Boolean(formik.errors.name)}
                                                helperText={formik.touched.name && formik.errors.name}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                variant="standard"
                                                className='mb-3 w-100'
                                                label="Mobile Number *"
                                                inputProps={{
                                                    maxLength: 10
                                                }}
                                                id="mobile"
                                                name="mobile"
                                                value={formik.values.mobile}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("mobile", e.target.value.replace(/[^0-9]/g, ''));
                                                }}
                                                error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                                                helperText={formik.touched.mobile && formik.errors.mobile}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="email"
                                                name="email"
                                                label="Email ID *"
                                                type="text"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                error={formik.touched.email && Boolean(formik.errors.email)}
                                                helperText={formik.touched.email && formik.errors.email}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="address"
                                                name="address"
                                                label="Address *"
                                                type="text"
                                                value={formik.values.address}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("address", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                }}
                                                error={formik.touched.address && Boolean(formik.errors.address)}
                                                helperText={formik.touched.address && formik.errors.address}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="city"
                                                name="city"
                                                label="City *"
                                                type="text"
                                                value={formik.values.city}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("city", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                }}
                                                error={formik.touched.city && Boolean(formik.errors.city)}
                                                helperText={formik.touched.city && formik.errors.city}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="state"
                                                name="state"
                                                label="State *"
                                                type="text"
                                                value={formik.values.state}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("state", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                }}
                                                error={formik.touched.state && Boolean(formik.errors.state)}
                                                helperText={formik.touched.state && formik.errors.state}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                variant="standard"
                                                className='mb-3 w-100'
                                                label="Postal Code *"
                                                inputProps={{
                                                    maxLength: 6
                                                }}
                                                id="pincode"
                                                name="pincode"
                                                value={formik.values.pincode}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("pincode", e.target.value.replace(/[^0-9]/g, ''));
                                                }}
                                                error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                                                helperText={formik.touched.pincode && formik.errors.pincode}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <Autocomplete
                                                disablePortal
                                                id="country"
                                                className='mb-3'
                                                name="country"
                                                getOptionLabel={option => option.label}
                                                options={cddl}
                                                onChange={(e, value) => {
                                                    //console.log('pas', value.value)
                                                    formik.setFieldValue('country', value.value);
                                                }}
                                                sx={{ width: '100%' }}
                                                renderInput={(params) => <TextField
                                                    variant="standard" {...params}
                                                    error={formik.touched.country && Boolean(formik.errors.country)}
                                                    helperText={formik.touched.country && formik.errors.country}
                                                    label="Select Country *" />}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="firmName"
                                                name="firmName"
                                                label="Firm Name *"
                                                type="text"
                                                value={formik.values.firmName}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("firmName", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                }}
                                                error={formik.touched.firmName && Boolean(formik.errors.firmName)}
                                                helperText={formik.touched.firmName && formik.errors.firmName}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="geographical"
                                                multiline
                                                rows={2}
                                                name="geographical"
                                                label="Your Geographical Coverage *"
                                                type="text"
                                                value={formik.values.geographical}
                                                onChange={(e) => {
                                                    formik.setFieldValue("geographical", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                }}
                                                // onChange={formik.handleChange}
                                                error={formik.touched.geographical && Boolean(formik.errors.geographical)}
                                                helperText={formik.touched.geographical && formik.errors.geographical}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextField
                                                className='mb-3 w-100'
                                                variant="standard"
                                                id="aboutbusiness"
                                                multiline
                                                rows={2}
                                                name="aboutbusiness"
                                                label="Tell us about your Business *"
                                                type="text"
                                                value={formik.values.aboutbusiness}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                    formik.setFieldValue("aboutbusiness", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                                }}
                                                error={formik.touched.aboutbusiness && Boolean(formik.errors.aboutbusiness)}
                                                helperText={formik.touched.aboutbusiness && formik.errors.aboutbusiness}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <div className='f12 mb-3'>
                                                <div className='d-flex align-items-center'>
                                                    <div><FormGroup>
                                                        <FormControlLabel className='f14' control={<Checkbox className='f14' checked={agree} onChange={haveAgree} />} label="" />
                                                    </FormGroup></div>
                                                    <div className='fw-bold'>I accept the <Link to="/terms-of-use" target='_blank'>Terms & Privacy Policy</Link></div>
                                                </div>
                                            </div>
                                            {!loading ? <Button color="error"
                                                disabled={!agree}
                                                variant="contained" className='w-100' type="submit">
                                                Submit
                                            </Button> : <LoadingButton className="w-100"
                                                loading
                                                //loadingPosition="end"
                                                variant="contained"
                                            >
                                                Submit...
                                            </LoadingButton>}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> : <div className='container pt-5 pb-5'>
                            <div className='col-lg-8 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                                <div className='card p-4 rounded-0 shadow-sm'>
                                    <div className="align-items-center text-center">
                                        <h3 className='d-inline-block m-0 fw-bold txtdgray'>
                                            Are you An <span className='txtred'>Authorised Dealer</span> ?</h3>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center text-center w-50 m-auto">
                                        <Button color="error" variant="contained" className='mt-4 px-4 py-2 fw-bold' color="error" onClick={() => { setIsADealer(true); toTop(); }}> Yes</Button>

                                        <Button color="error" variant="contained" className='mt-4 px-4 py-2 fw-bold' color="error" onClick={() => { setIsADealer(false); setShow(true); toTop(); }} >
                                            No</Button>

                                    </div>

                                </div>
                            </div>
                        </div>}</>}
            </div>
            <div style={{ clear: 'both', height: '40px' }}></div>
            <FotterMain />
        </>
    )
}

export default BecomeAHiValuePlusDealer